import Select from 'components/Common/Form/Input/Select'
import FormatCurrency from 'components/Common/FormatCurrency'
import React from 'react'

export function parseTailorMadeTourBudgetValue(value: string): App.Tours.TailorMadeTourRequest['budget'] {
  const [from, to] = value.split('-')
  return {
    from: from === 'any' ? 'any' : Number(from),
    to: to === 'any' ? 'any' : Number(to),
  }
}

function parseDefaultValue(defaultValue?: App.Tours.TailorMadeTourRequest['budget']): string | undefined {
  if (!defaultValue) return
  return `${defaultValue.from}-${defaultValue.to}`
}

interface Props {
  name: string
  defaultValue?: App.Tours.TailorMadeTourRequest['budget']
}

function TailorMadeTourBudgetInput({ name, defaultValue }: Props) {
  return <Select
    name={name}
    defaultValue={parseDefaultValue(defaultValue)}
    label="What is your overall budget for this tour"
    placeholder="Select approximate budget"
    required
  >
    <option value="0-5000"><FormatCurrency value={0} /> - <FormatCurrency value={5_000} /></option>
    <option value="5000-10000"><FormatCurrency value={5_001} /> - <FormatCurrency value={10_000} /></option>
    <option value="10000-15000"><FormatCurrency value={10_001} /> - <FormatCurrency value={15_000} /></option>
    <option value="15000-20000"><FormatCurrency value={15_001} /> - <FormatCurrency value={20_000} /></option>
    <option value="20000-any"><FormatCurrency value={20_000} />+</option>
  </Select>
}

export default TailorMadeTourBudgetInput
